<template>
  <div class="main-container" v-if="formData">
    <Form ref="myForm" :model="formData" :label-width="100" class="page-form" :show-message="false">
      <Row>
        <Col :span="6">
          <FormItem label="保单量">{{ formData.policyNum }}</FormItem>
        </Col>
        <Col :span="6">
          <FormItem label="规模保费">{{ formData.fee }} 港币</FormItem>
        </Col>
        <Col :span="6">
          <FormItem label="结算积分">{{ formData.amount }}</FormItem>
        </Col>
      </Row>
    </Form>

    <Tabs v-model="tableType" :animated="false" @on-click="handleToggleTab">
      <TabPane :label="getTabLabel('保单结算', 'ledgerDown')" name="ledgerDown" />
      <TabPane :label="getTabLabel('周边收支', 'extsvcItem')" name="extsvcItem" />
      <TabPane :label="getTabLabel('财务增减', 'financeItem')" name="financeItem" />
    </Tabs>

    <Table
      :columns="columns"
      :data="tableData"
      @on-select="onSelect"
      @on-select-cancel="onSelectCancel"
      @on-select-all="onSelect"
      @on-select-all-cancel="onSelectAllCancel"
    >
      <template slot-scope="{ row }" slot="fee">
        <div v-if="row.fyb || row.paymentPeriod">
          <span>{{ row.fyb }}</span>
          <lzDicTxt dicType="CURRENCY_INT" :dicCode="row.currencyType" />
          <span v-if="row.fyb && (row.paymentPeriod || row.paymentType)">/</span>
          <span>{{ row.paymentPeriod }}</span>
          <lzDicTxt v-if="row.paymentType" :dicCode="row.paymentType" dicType="GUARANTEE_TYPE"></lzDicTxt>
          <span v-else>年</span>
        </div>
        <div v-else>-</div>
      </template>
    </Table>

    <div class="bottom-btn">
      <Button type="primary" ghost @click="backPage()">返回</Button>
      <Button v-if="mode === 'add' || mode === 'edit'" :loading="btnLoading" type="primary" @click="handleConfirm">确定</Button>
    </div>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzDicSelect from '@/components/commons/lzDicSelect';
import tableMixin from './table.mixin.js';

export default {
  mixins: [common, tableMixin],
  components: {
    lzDicSelect,
    lzDicTxt
  },
  data() {
    return {
      id: '',
      mode: '',
      formData: {},
      btnLoading: false
    };
  },
  computed: {
    tableData() {
      if (this.tableType === 'ledgerDown') {
        return this.ledgerDownList;
      } else if (this.tableType === 'extsvcItem') {
        return this.extsvcItemList;
      } else if (this.tableType === 'financeItem') {
        return this.financeItemList;
      }
      return [];
    }
  },
  filters: {
    dateSrtFilter(str) {
      if (!str) return '';
      return str.substr(0, 10);
    }
  },
  created() {
    this.mode = this.$route.query.mode || 'read';
    this.id = this.$route.query.id || '';
  },
  activated() {
    this.getDetail();
  },
  methods: {
    handleToggleTab(tabName) {
      console.log('tabName', tabName);
    },
    // 获取详情
    getDetail() {
      this.$http({
        url: '/buz/settlementDown/queryDetail',
        type: 'GET',
        data: { id: this.id }
      }).then(res => {
        console.log('res', res);
        this.formData = res.data;
        // 转介人结算列表
        this.ledgerDownList = res.data.ledgerDownList;
        // 周边收支列表
        this.extsvcItemList = res.data.extsvcItemList;
        // 财务增减列表
        this.financeItemList = res.data.financeItemList;
      });
    },
    // 返回
    backPage() {
      this.back(this.$route.query.backUrl);
    },
    handleConfirm() {
      this.btnLoading = true;
      this.$http({
        url: '/buz/settlementDown/updateStatus',
        type: 'POST',
        data: {
          id: this.formData.id,
          status: 4
        }
      })
        .then(res => {
          console.log('res', res);
          this.$notice.success('操作成功');
          this.btnLoading = false;
          this.mode = 'read';
          this.getDetail();
        })
        .catch(err => {
          this.btnLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.main-container {
  padding-bottom: 100px;
  .ivu-col .ivu-form-item {
    width: 100% !important;
  }
}
.bottom-btn {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 999;
  width: 100%;
  height: 70px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #ccc;
  .ivu-btn {
    width: 140px;
    height: 35px;
  }
  .ivu-btn + .ivu-btn {
    margin-left: 20px;
  }
}
</style>
